import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { CustomerBillService, CustomerBillData, PrForBill, CreditNote, CFDI, CustomerBillId, /* Complement */ } from '../../services/customer-bill.service';
import { CustomerSupplierService, CustomerSupplierId } from '../../services/customer-supplier.service';
import { FiscalDataService, FiscalDataId } from '../../services/fiscal-data.service';
import { ProductionOrderService, ProductionOrderData, ProductionOrderId } from '../../services/production-order.service';
import { RemissionService, RemissionId } from '../../services/remission.service';
import { CatalogsSettingsService, PayrollId } from '../../services/catalogs-settings.service';
import { ProductVntaService, PrVntaId } from '../../services/product-vnta.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { Cells, Table, RightCell, Ref } from '../../globals';
import { EmployeeId, EmployeeService } from '../../services/employee.service';
import { FirestoreService } from '../../services/firestore/firestore.service';

@Component({
  selector: 'app-update-customer-bill',
  templateUrl: './update-customer-bill.component.html',
  styleUrls: ['./update-customer-bill.component.css']
})
export class UpdateCustomerBillComponent implements OnInit, OnDestroy {
  customerBillId: string;

  customerId: string;
  fiscalDataId: string;
  customerName: string = '';
  fiscalData:any = {};

  form: FormGroup;
  cfdiForm: FormGroup;
  cfdiSelects: any = {};
  folio: number;

  initialAssociatedBillId: string = '';
  
  settings: PayrollId;
  creditNoteNextFolio: number = 0;
  pickadateParams = Utils.pickadateParams();


  subs = [];

  cancelUrl: string = '/customerBill';
  constructor(
    private service: CustomerBillService,
    private firestoreService: FirestoreService,
    private customerService: CustomerSupplierService,
		private fiscalDataService: FiscalDataService,
    private customerBillData: CustomerBillData,
    private productionOrderService: ProductionOrderService,
    private employeeService: EmployeeService,
    private remissionService: RemissionService,
    private settingsService: CatalogsSettingsService,
    private prVntaService: ProductVntaService,
    private prCmpaService: ProductCmpaService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.customerBillId = this.activatedRoute.snapshot.paramMap.get('id');

    if(localStorage.returnToDisplay){
      //console.log(localStorage.returnToDisplay);
      this.cancelUrl = `/vw_customerBill/${this.customerBillId}`;
      //console.log(this.cancelUrl)
      delete localStorage.returnToDisplay;
    }

    this.cfdiSelects = customerBillData.allSelects;

    this.customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.fiscalDataId = this.activatedRoute.snapshot.paramMap.get('fiscalDataId');
    this.subs.push(
      this.customerService.getCustomerSupplier(this.customerId).subscribe(c => { this.customerName = c.name })
    );
    this.subs.push(
      this.fiscalDataService.getFiscalData(this.fiscalDataId).subscribe( ({ creditLimitDays = 0, ...fiscalData }) => {
        this.fiscalData = { creditLimitDays, ...fiscalData };
        if(!this.form.get('payDate').value) this.onChangeDate(this.today)
      })
    );
    this.subs.push(
      this.prVntaService.getPrVntas().subscribe(prVntas => {
        this.rPrB_rowsRead[1] = prVntas.map(({data: {name}, ...prVnta}) => { this.prVntas[prVnta.id] = {...prVnta}; return {class: name, ...prVnta} });
      })
    );
    this.subs.push(
      this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
        this.rPrB_rowsRead[2] = prCmpas.map(({data: {name}, ...prCmpa}) => { this.prCmpas[prCmpa.id] = {...prCmpa}; return {class: name, ...prCmpa} });
      })
    );

    this.productionOrders = {};
    this.subs.push(
      this.productionOrderService.getProductionOrders().subscribe(productionOrders => {
        this.rowsRead[0] = productionOrders.filter(productionOrder => {
          this.productionOrders[productionOrder.id$] = {...productionOrder};
          if(productionOrder.customer.id == this.customerId) return productionOrder;
        });
      })
    );
    this.remissions = {};
    this.subs.push(
      this.remissionService.getRemissions().subscribe(remissions => {
        this.rPrB_rowsRead[0] = remissions.filter(remission => {
          remission.name = remission.folio;
          remission.addressFull = `${remission.addressObj.street}, #${remission.addressObj.externalNumber}`;
          this.remissions[remission.id] = {...remission};
          if(remission.fiscalDataObj.id == this.fiscalDataId && !remission.status) return remission;
        });
      })
    );
    this.employees = {};
    this.subs.push(
      this.employeeService.getEmployees().subscribe((employees: EmployeeId[]) => {
        this.rowsRead[1] = employees.map(employee => {
          employee.name += ` ${employee.lastName}`;
          this.employees[employee.id] = employee;
          return employee;
        });
      })
    );
    this.customers = {};
    this.subs.push(
      this.customerService.getCustomers().subscribe(customers => {
        this.rowsRead[2] = customers.map(({id$: id, ...customer}) => {
          return this.customers[id] = <any>{id, ...customer};
        });
      })
    );
    this.fiscalDatas = {};
    this.subs.push(
      this.fiscalDataService.getAllFiscalDatas().subscribe(fiscalDatas => {
        this.rowsRead[3] = fiscalDatas.filter(fiscalData => {
          fiscalData.name = fiscalData.businessName;
          this.fiscalDatas[fiscalData.id] = {...fiscalData};
          if(fiscalData.customerId) return fiscalData;
        });
      })
    );
    //get bills of same fiscalDataRef
    //let fiscalDataRef = this.firestoreService.doc(`${this.fiscalDataService.collection}/${this.fiscalDataId}qwerty`).ref;
    this.firestoreService.colWithIds<CustomerBillId>(this.service.collection, ref => ref.where('active', '==', true)).then(bills => {
      bills = bills.filter(bill => bill.fiscalDataRef.id == this.fiscalDataId);
      console.log('Got bills:', bills)
      this.bills = {};
      for(let bill of bills) this.bills[bill.id] = bill;
      this.rowsRead[4] = bills.filter(bill => !bill.associatedToBillId || bill.associatedToBillId == this.customerBillId).map(bill => {
        bill['name'] = bill.folio;
        bill['statusName'] = this.customerBillData.status[bill.status || 'key0'];
        bill.uuid = bill.uuid || 'N.A.';
        bill['money_total'] = this.money(bill.totals.total);
        return bill;
      });
    });
  }

  ngOnInit() {
    this.createForm();
    this.createCfdiForm();
    this.subs.push(
      this.settingsService.getPayrollSettings('1').subscribe(settings => {
        this.settings = settings;
        this.creditNoteNextFolio = settings.folios.billCreditNote;
      })
    );
    
    let sub = this.service.getCustomerBill(this.customerBillId).subscribe(([{status='key0', productionOrderRef=<Ref>{}, employeeRef=<Ref>{}, /* complements=[], */ ...customerBill}]) => {
      sub.unsubscribe();
      this.initialAssociatedBillId = customerBill.associatedBillId || '';
      this.form.patchValue(customerBill);
      this.cfdiForm.patchValue(customerBill.cfdi);
      this.selectedIds = [productionOrderRef.id, employeeRef.id, '', customerBill.extraFiscalDataId, customerBill.associatedBillId || ''];
      this.prForBills = customerBill.prForBills;
      this.creditNotes = customerBill.creditNotes.map(({status='key0', ...c}) => ({status, ...c}) );
      /* this.complements = complements.map(c => new Complement(0,c)); */
      let remissions = this.prForBills.map(r => r.remissionId).filter(r => r != '');
      this.prForBillRemissions = new Set(remissions);

      this.billUuid = customerBill.uuid || '';
    });
  }
	ngOnDestroy() {
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm(){
    this.form = this.fb.group({
      folio: ['', Validators.required],
      date: [this.today, Validators.required],
      receptionDate: ['', Validators.required],
      payDate: ['', [Validators.required]],
      associatedRelationType: '',
      notes: ''
    });
  }
  createCfdiForm(){
    this.cfdiForm = this.fb.group(<CFDI>{
      payForm: 'key0',
      payMethod: 'key0',
      payConditions: 'key0',
      cfdiUsage: 'key0',
      currency: 'key0',
      change: 1,
      bankDigits: ''
    })
  }

  onSubmit({ value, valid }: { value: any, valid: any }){

    value.customerId = this.customerId;
    value.customerRef = this.customerId;
    value.fiscalDataRef = this.fiscalData.id;
    value.productionOrderRef = this.selectedProductionOrderId;
    value.employeeRef = this.selectedEmployeeId;
    value.extraFiscalDataId = this.extraRfc ? this.selectedFiscalDataId : '';
    value.associatedBillId = this.selectedBillId;
    value.prForBills = this.prForBills;
    value.creditNotes = this.creditNotes.map(({returnQuantity, ...nc}) => ({returnQuantity: nc.isReturning ? returnQuantity : 1, ...nc}));
    value.cnLength = this.creditNotes.length;
    /* value.complements = this.complements.map(c => ({...c})) */
    value.totals = { creditNote: this.creditNotesTotal, ...this.totals.reduce( (acc, cur) => {acc[cur.key] = cur.get; return acc; }, {})};

    value.cfdi = this.cfdiForm.value;
    
    this.service.updateCustomerBill(this.customerBillId, value);
    if(this.selectedBillId) this.service.updateByField({associatedToBillId: this.customerBillId}, this.selectedBillId);
    if(this.initialAssociatedBillId && this.selectedBillId != this.initialAssociatedBillId) this.service.updateByField({associatedToBillId: ''}, this.initialAssociatedBillId);
    this.updateRemissions(this.customerBillId);
    this.updateSettings();
    this.service.windowReplace('view', this.customerBillId);
  }
  
  updateRemissions(billId){
    let remRefs: {[remId: string]: {ids: string[], qua: number[]}};
    //Past remissions
    this.prForBills.map(r => {
      if(r.remissionId) this.prForBillRemissions.add(r.remissionId);
    });
    this.prForBillRemissions.forEach(remissionId => {
      //remRefs[remissionId] = {ids: }
      let sub = this.remissionService.getRemission(remissionId).subscribe(([remission]: RemissionId[]) => {
        sub.unsubscribe();
        let pr = this.prForBills.find(({remissionId: remId}) => remId == remissionId);
        let status = 0;
        let billRefs = remission.billRefs || [];
        let billQuantitys = remission.billQuantitys || [];
        if(billRefs.includes(billId)){
          let index = billRefs.indexOf(billId);
          if(pr){
            billQuantitys[index] = pr.quantity;
          }else{
            billRefs.splice(index, 1);
            billQuantitys.splice(index, 1);
          }
        }else{
          if(!pr) return;
          billRefs.push(billId);
          billQuantitys.push(pr.quantity);
        }
        let quantitysSum = billQuantitys.reduce((acc, cur) => acc + cur, 0);
        if(quantitysSum >= remission.quantity) status = 1;
        this.remissionService.updateByField( {billRefs, billQuantitys, status}, remissionId);
      });
    } );
  }
  updateSettings(){
    this.settings.folios.billCreditNote = this.creditNoteNextFolio;
    this.settingsService.putPayrollSettings(this.settings, '1');
  }


  onChangeDate(date){
    const payDate = date ? this.stringifyDate(new Date( new Date(date).getTime() + (this.fiscalData.creditLimitDays+1) * 86400000 )) : '';
    this.form.get('payDate').patchValue(payDate);
  }

  stringifyDate(date: Date){
    var dd:string = date.getDate() + '';
    var mm:string = date.getMonth()+ 1 + '';
    var yyyy = date.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  money = Utils.money;

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  
  selectedIds: string[] = []
  productionOrders: any = {};
  employees: {[s: string]: EmployeeId} = {};
  customers: {[s: string]: CustomerSupplierId} = {};
  fiscalDatas: {[s: string]: FiscalDataId} = {};
  bills: {[s: string]: CustomerBillId} = {};
  
  get selectedProductionOrderId(): string { return this.selectedIds[0] || '' };
  get selectedEmployeeId(): string { return this.selectedIds[1] || '' };
  get selectedCustomerId(): string { return this.selectedIds[2] || '' };
  get selectedFiscalDataId(): string { return this.selectedIds[3] || '' };
  get selectedBillId(): string { return this.selectedIds[4] || '' };
  get selectedBillString(): string {
    if(!this.selectedBillId || !this.bills[this.selectedBillId]) return '';
    let {folio, date, totals: {total}, uuid=''} = this.bills[this.selectedBillId];
    return `Folio: ${folio}, Fecha: ${date}, Importe: ${Utils.money(total)}, UUID: ${uuid}`;
  }

  get readValid(){ return !this.form.get('associatedRelationType').value || !!this.selectedBillId };
  get extraRfc(){ return this.fiscalDatas[this.selectedFiscalDataId] }

  currentReadIndex: number;
  currentCreditNote: CreditNote;
  rowsRead = [[], [], [], []];
  columnsRead = [
    [//odp
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ],
    [//employee
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Nombre', name: 'name' },
      { title: 'Correo electrónico', name: 'email' },
    ],
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [//fiscalData
      { title: 'Razón Social', name: 'name', sort: 'asc' },
      { title: 'RFC', name: 'rfc' }
    ],
    [//bill
      {title: 'Folio', name: 'name'},
      {title: 'Fecha', name: 'date'},
      {title: 'Fecha Recepción', name: 'receptionDate'},
      {title: 'Fecha Pago', name: 'payDate'},
      {title: 'Estatus', name: 'statusName'},
      {title: 'UUID', name: 'uuid'},
      {title: 'Total', name: 'money_total'},
    ],
  ]

  openModalRead(index: number, creditNote: CreditNote = null) {
    this.currentReadIndex = index;
    this.currentCreditNote = creditNote;
    
    if(index == 2 && this.extraRfc){
      this.selectedIds[2] = '';
      this.selectedIds[3] = '';
      return;
    }
    
    this.data = index == 3 ? this.rowsRead[3].filter(({customerId}) => customerId == this.selectedCustomerId) : this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead(back=false) {
    if(this.currentReadIndex == 3 && back) return this.openModalRead(2);
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentCreditNote) this.currentCreditNote.extraUuid = row.uuid || '';
    else this.selectedIds[this.currentReadIndex] = row.id;
    if(this.currentReadIndex == 2) return this.openModalRead(3);
    this.closeModalRead();
  }

  onAssociatedRelationTypeChange(){
    if(!this.form.get('associatedRelationType').value) this.selectedIds[4] = '';
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

  //////////////////////////////////////////////////////////////////////////////////////////////PR_FOR_BILL
  modalActionsPrForBill = new EventEmitter<string|MaterializeAction>();
  modalParamsPrForBill = [{dismissible: true}];
  
  prForBill: PrForBill;
  prForBills: PrForBill[] = [];
  prForBillRemissions: Set<string>;
  get prForBillIsValid(): boolean {
    return !!(
      this.prForBill.product &&
      this.prForBill.quantity &&
      this.prForBill.pricePerUnit
    )
  }
  calculateTotals(){
    let {defaults: {isrRetention: retPct, iva: ivaPct, ivaRetention: retIvaPct}} = this.settings;
    let { quantity, pricePerUnit, retentionApplies, ivaApplies, discountPct } = this.prForBill;

    let amountNoDisc = +(quantity*pricePerUnit).toFixed(2);

    let amount = amountNoDisc - +(amountNoDisc*(discountPct/100)).toFixed(2);
    let retIsr = +(retentionApplies ? amount*retPct/100 : 0).toFixed(2);
    let retIva = +(retentionApplies && ivaApplies ? amount*retIvaPct/100 : 0).toFixed(2);
    let subtotal = +(amount - retIsr - retIva).toFixed(2);
    let iva = +(ivaApplies ? amount*ivaPct/100 : 0).toFixed(2);
    let total = +(subtotal + iva).toFixed(2);

    this.prForBill = { ...this.prForBill, amount, amountNoDisc, retIsr, retIva, subtotal, iva, total };
  }
  get retIsr(): number { return this.prForBills.reduce((acc,{retIsr}) => +(acc + retIsr).toFixed(2), 0) }
  get retIva(): number { return this.prForBills.reduce((acc,{retIva}) => +(acc + retIva).toFixed(2), 0) }
  get subtotal(): number { return this.prForBills.reduce((acc,{subtotal}) => +(acc + subtotal).toFixed(2), 0) }
  get iva(): number { return this.prForBills.reduce((acc,{iva}) => +(acc + iva).toFixed(2), 0) }
  get total(): number { return this.prForBills.reduce((acc,{total}) => +(acc + total).toFixed(2), 0) }
  get amountNoDisc(): number { return +this.prForBills.reduce((acc,{amountNoDisc}) => acc + amountNoDisc, 0).toFixed(2) }
  get totals(): any[] { return [
    {name: 'Subtotal sin descuento', key: 'amountNoDisc', get: +this.amountNoDisc.toFixed(2) },
    {name: 'Retención ISR', key: 'retIsr', get: +this.retIsr.toFixed(2) },
    {name: 'Retención IVA', key: 'retIva', get: +this.retIva.toFixed(2) },
    {name: 'Subtotal', key: 'subtotal', get: +this.subtotal.toFixed(2) },
    {name: 'IVA', key: 'iva', get: +this.iva.toFixed(2) },
    {name: 'Total', key: 'total', get: +this.total.toFixed(2) },
  ] }
  
  currentTabPrForBill: number = 0;
  currentEditingIndexPrForBill: number;
  openModalPrForBill(editingIndex?: number) {
    this.currentEditingIndexPrForBill = editingIndex;
    this.prForBill = {...this.service.defaultPrForBill}
    this.continuePrForBill( editingIndex == undefined ? 0 : this.LAST );
    this.modalActionsPrForBill.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrForBill() {
    this.modalActionsPrForBill.emit({ action: 'modal', params: ['close'] });
  }
  continuePrForBill(tabIndex: number){
    if(tabIndex == 0){
      this.subSelectedIds = [];
    }else if(tabIndex < this.LAST){
      this.subCurrentReadIndex = tabIndex - 1;
      this.rPrB_data = this.rPrB_rowsRead[this.subCurrentReadIndex];
      if(tabIndex == 1){
        //if(!this.selectedProductionOrderId) return toast('Elija una orden de producción.', 3000);
        this.rPrB_data = !this.selectedProductionOrderId ? this.rPrB_data : this.rPrB_data.filter(remission => remission.productionOrder.id == this.selectedProductionOrderId);
      }
      this.rPrB_config = this.rPrB_configs[0];
      this.rPrB_onChangeTable(this.rPrB_config);
    }else{
      if(this.currentEditingIndexPrForBill != undefined) this.prForBill = {...this.prForBills[this.currentEditingIndexPrForBill]};
      else{
        let item, {quantity: remQuantity = 0, productionOrder: {id: odpId = ''} = {}} = this.remissions[this.selectedRemissionId] || {};
        if(this.selectedRemissionId){
          if(!odpId) toast('No se encontró orden de producción en la remisión.');
          let odp: ProductionOrderId = this.productionOrders[odpId] || {};
          let prVnta: PrVntaId = this.prVntas[odp.prVntaId] || {};
          item = {...this.remissions[this.selectedRemissionId], ...prVnta, ...odp};
        }
        else if(this.selectedPrVntaId) item = this.prVntas[this.selectedPrVntaId];
        else if(this.selectedPrCmpaId) item = this.prCmpas[this.selectedPrCmpaId];

        let { quantity=0, pricePerUnit=0, productSatKey='32131021', unitSatKey='H87', name='', description='', longDescription:ld='', prClient: {code=''} = {}} = item;

        this.prForBill.productSatKey = productSatKey as '01010101';
        this.prForBill.unitSatKey = unitSatKey as 'H87';
        this.prForBill.remissionId = this.selectedRemissionId;
        this.prForBill.odpId = (item.productionOrder || {}).id || '';
        this.prForBill.odpFolio = (item.productionOrder || {}).folio || '';
        this.prForBill.productRef = this.selectedPrVntaId || this.selectedPrCmpaId; this.prForBill.isVnta = !this.selectedPrCmpaId;
        this.prForBill.product = ld || name || description;
        this.prForBill.quantity = remQuantity || quantity;
        this.prForBill.pricePerUnit = +pricePerUnit.toFixed(4);
        this.prForBill.notes = code ? `Clave: ${code}` : '';
      }
    }
    this.currentTabPrForBill = tabIndex;
  }
  
  touchPrForBill(){
    if(this.prForBills.length){
      if(this.prForBills.some(pr => pr.productSatKey == '84111506') && this.prForBill.productSatKey != '84111506') return toast(`Los productos deben tener la clave de producto '84111506'`, 3000);
      if(!this.prForBills.some(pr => pr.productSatKey == '84111506') && this.prForBill.productSatKey == '84111506') return toast(`Los productos no pueden tener la clave de producto '84111506'`, 3000);
    }
    this.calculateTotals();
    if(this.currentEditingIndexPrForBill == undefined) this.prForBills.push( {...this.prForBill} );
    else this.prForBills[this.currentEditingIndexPrForBill] = {...this.prForBill};
    if(this.prForBill.remissionId) this.prForBillRemissions.add(this.prForBill.remissionId);
    this.closeModalPrForBill();
  }
  removePrForBill(index) {
    if(this.prForBills[index].remissionId) this.prForBillRemissions.add(this.prForBills[index].remissionId);
    this.prForBills.splice(index,1);
  }

  cleanPrString(field: keyof PrForBill){
    this.prForBill[<any>field] = Utils.cleanString(this.prForBill[field], this.customerBillData.PRODUCT_ALLOWED_CHARS);
  }

  //////////////////////////////////////////////////////////////////////////READ MODAL DATA
  LAST = 4;

  remissions = {};
  prVntas = {};
  prCmpas = {};
  /* get subItems(){
    let i = this.subCurrentReadIndex;
    return !i ? this.remissions : i == 1 ? this.prVntas : this.prCmpas;
  } */

  subCurrentReadIndex: number;
  subSelectedIds: string[] = [];
  get selectedRemissionId(): string { return this.subSelectedIds[0] || '' };
  get selectedPrVntaId(): string { return this.subSelectedIds[1] || '' };
  get selectedPrCmpaId(): string { return this.subSelectedIds[2] || '' };

  rPrB_selectRead({row: {id}}){
    this.subSelectedIds[this.subCurrentReadIndex] = id;
    this.continuePrForBill(this.LAST);
  }

  rPrB_rowsRead = [[],[],[]];
  rPrB_columnsRead = [
    [//remission
      {title: 'Folio', name: 'name'},
      {title: 'Dirección de entrega', name: 'addressFull'},
      {title: 'Fecha', name: 'date'},
      {title: 'Cantidad', name: 'quantity'},
    ],
    [//prVnta
      {title: 'Nombre', name: 'name',sort: 'asc'},
      {title: 'Descripción', name: 'description'},
      {title: 'Clasificación' , name: 'class'},
      {title: 'Código', name: 'code'},
      {title: 'Clave de producto', name: 'productSatKey'},
    ],
    [//prCmpa
      {title: 'Nombre', name: 'name',sort: 'asc'},
      {title: 'Descripción', name: 'description'},
      {title: 'Clasificación' , name: 'class'},
      {title: 'Código', name: 'code'},
    ]
  ]


  rPrB_data:Array<any>;
  rPrB_rows:Array<any> = [];
  rPrB_page:number = 1;
  rPrB_itemsPerPage:number = 5;
  rPrB_maxSize:number = 5;
  rPrB_numPages:number = 1;
  rPrB_length:number = 0;

  
  rPrB_configs:any = this.rPrB_columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  rPrB_config;

  /*********** Filter, sort, and pagination */

	rPrB_changePage(page:any, data:Array<any> = this.rPrB_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  rPrB_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.rPrB_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }


  rPrB_changeFilter(data:any = this.rPrB_data, config:any):any {
    console.clear();
    console.log(this.rPrB_columnsRead[0])
    let filteredData:Array<any> = data;
    this.rPrB_columnsRead[0].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.rPrB_config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.rPrB_columnsRead[0].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.rPrB_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  rPrB_onChangeTable(config:any, page:any = {page: this.rPrB_page, itemsPerPage: this.rPrB_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.rPrB_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.rPrB_config.sorting, config.sorting);
    }

    let filteredData = this.rPrB_changeFilter(this.rPrB_data, this.rPrB_config);
    let sortedData = this.rPrB_changeSort(filteredData, this.rPrB_config);
    this.rPrB_rows = page && config.paging ? this.rPrB_changePage(page, sortedData) : sortedData;
    this.rPrB_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////READ MODAL DATA

  //////////////////////////////////////////////////////////////////////////////////////////////PR_FOR_BILL

  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE
  modalActionsCreditNote = new EventEmitter<string|MaterializeAction>();
  modalParamsCreditNote = [{dismissible: true}];
  
  creditNote: CreditNote = {...this.service.defaultCreditNote};
  creditNotes: CreditNote[] = [];
  get creditNoteIsValid(): boolean {
    return !!(
      this.creditNote.date &&
      this.creditNote.total
    )
  }
  get creditNotesTotal(): number { return this.creditNotes.reduce((acc,{total}) => acc + total, 0) }

  onInputSubtotal(){
    let {subtotal} = this.creditNote;
    this.creditNote.total = +(subtotal * 1.16).toFixed(2);
    this.creditNote.iva = +(subtotal * .16).toFixed(2);
  }
  onInputTotal(){
    let subtotal = this.creditNote.total / 1.16;
    this.creditNote.subtotal= +subtotal.toFixed(2);
    this.creditNote.iva= +(subtotal * .16).toFixed(2);
  }
  onChangeIsReturning(value = !this.creditNote.isReturning){
    this.creditNote.isReturning = value;
    if(!this.creditNote.isReturning || !this.prForBills.length) return;
    let [pr] = this.prForBills;
    this.creditNote.subtotal = pr.pricePerUnit * this.creditNote.returnQuantity;
    this.onInputSubtotal();
  }
  
  billUuid: CustomerBillId['uuid'] = '';
  currentEditingIndexCreditNote: number;
  openModalCreditNote(editingIndex?: number) {
    console.log(this.service.defaultCreditNote,  this.creditNote);
    this.currentEditingIndexCreditNote = editingIndex;
    this.creditNote = editingIndex == undefined ? {...this.service.defaultCreditNote, extraUuid: this.billUuid} : {...this.service.defaultCreditNote, ...this.creditNotes[editingIndex]};
    if(!this.creditNote.folio) this.creditNote.folio = `${this.creditNoteNextFolio}`;
    this.modalActionsCreditNote.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCreditNote() {
    this.modalActionsCreditNote.emit({ action: 'modal', params: ['close'] });
  }
  
  touchCreditNote(){
    if(this.currentEditingIndexCreditNote == undefined) this.creditNotes.push( {...this.creditNote} );
    else this.creditNotes[this.currentEditingIndexCreditNote] = {...this.creditNote};
    this.creditNoteNextFolio++;
    this.closeModalCreditNote();
  }
  removeCreditNote(index) {
    this.creditNotes.splice(index,1);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE

  /* //////////////////////////////////////////////////////////////////////////////////////////////COMPLEMENT
  modalActionsComplement = new EventEmitter<string|MaterializeAction>();
  modalParamsComplement = [{dismissible: true}];
  
  complement: Complement = new Complement(0);
  complements: Complement[] = [];
  complementsTable: Table = {
    parent: this,
    caption: 'Complementos de pago',
    columns1: Cells(['Folio','Fecha','Método de pago','Moneda','Tipo de cambio','No. Parcialidad','IVA','Subtotal','IVA total','Total']),
    get rows1(){ return this.parent.complements.map((c: Complement) =>{
      let data: CustomerBillData = this.parent.customerBillData;
      return Cells([
        c.folio, c.date, data.payMethodSelect[c.payMethod].full, data.currencySelect[c.currency].full,
        c.change, c.bias, RightCell(`${c.iva}%`), RightCell(Utils.money(c.subtotal)), RightCell(Utils.money(c.ivatotal)), RightCell(Utils.money(c.total)),
      ])
    } ) }
  }

  onChangeTotal(total: number){
    let subtotal = total / (1 + this.complement.iva/100);
    this.complement.subtotal= +subtotal.toFixed(2);
  }
  
  ceiComplement: number;
  openModalComplement(editingIndex?: number) {
    this.ceiComplement = editingIndex;
    this.complement = new Complement(this.complements.length+1, this.complements[editingIndex]);
    this.modalActionsComplement.emit({ action: 'modal', params: ['open'] });
  }
  closeModalComplement() {
    this.modalActionsComplement.emit({ action: 'modal', params: ['close'] });
  }
  
  touchComplement(){
    let c = new Complement(0, this.complement);
    if(this.ceiComplement == undefined) this.complements.push(c);
    else this.complements[this.ceiComplement] = c;
    this.closeModalComplement();
  }
  removeComplement(index) {
    this.complements.splice(index,1);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////COMPLEMENT */

}